import { render, staticRenderFns } from "./RemoteVDDialog.vue?vue&type=template&id=f6f9c3fe&scoped=true"
import script from "./RemoteVDDialog.vue?vue&type=script&lang=ts"
export * from "./RemoteVDDialog.vue?vue&type=script&lang=ts"
import style0 from "./RemoteVDDialog.vue?vue&type=style&index=0&id=f6f9c3fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f9c3fe",
  null
  
)

export default component.exports